export default "__VITE_ASSET__CHtSIvYx__"